import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UploadSourceType } from '../../enums/upload-source-type.enum';
import { IUploadSourceModel } from 'app/shared/models/upload-source.model';

@Component({
    selector: 'kh-select-upload-source',
    styleUrls: ['./select-upload-source.component.less'],
    templateUrl: './select-upload-source.component.html',
    standalone: false
})
export class SelectUploadSourceComponent {
  @Output() public closed = new EventEmitter<IUploadSourceModel>();
  @Input() public acceptedExtensions: string = "*.*";

  public constructor(
    private readonly bsModalRef: BsModalRef) {
  }

  public cancel(): void {
    this.bsModalRef.hide();
  }

  public useWebCam(): void {
    this.closed.emit({ source: UploadSourceType.WebCam, files: null });
    this.bsModalRef.hide();
  }

  public uploadFile(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files;

    this.closed.emit({ source: UploadSourceType.File, files: files });
    this.bsModalRef.hide();
  }
}
